<template>
  <div>
    <el-popover
    placement="top-start"
    title="设备信息"
    width="200"
    trigger="hover">
    <div>
      <div v-if="(message.state == null || message.state == '') && (message.devId == null || message.devId == '')">{{ '设备名：'+message.devName }}</div>
      <div v-if="message.devId">{{ '设备ID：'+message.devId }}</div>
      <div v-if="message.state">状态: <span :style="{color:message.color}">{{ message.txt =='在线' && !!!message.devId ?'未安装':message.txt }}</span> </div>
    </div>
    <div slot="reference">
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" >
            <g id="项目基本信息备份" transform="translate(-735.000000, -535.000000)" :fill="backColor" :stroke="borderColor">
                <g id="编组-3" transform="translate(735.000000, 535.000000)">
                    <rect id="矩形" x="0.5" y="0.5" width="17" height="29" rx="4"></rect>
                    <rect id="矩形备份-6" x="23.5" y="5.5" width="6" height="19" rx="2.5"></rect>
                    <rect id="矩形" x="5.5" y="7.5" width="7" height="4" rx="2"></rect>
                </g>
            </g>
        </g>
    </svg>
    </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  inject:['getNode'],
  data() {
    return {
      borderColor: '#979797',          // 边框颜色
      backColor: 'transparent',        // 背景颜色
      openPolice: false,               // 开启报警
      openOnLine: false,               // 是否在线
      openOffLine:false,               // 是否离线
      polineColor: 'red',              // 报警颜色
      onLineColor: 'green',            // 在线颜色
      offLineColor: '#979797',         // 离线颜色
      interArr:[],
      defaultColor:'#979797',
      message:{
        devName:'门磁',
        state:false,
        color:'#979797',
        txt:'',
        devId:''
      },
    };
  },
  mounted(){
    const node = this.getNode();
    console.log('测试-----?????------++++++',node.getData())
    node.on('change:data',(res)=>{
      console.log("svg----------",res)
      let {current}  = res;
      if(current.svgData.borderColor != '')
        this.borderColor = current.svgData.borderColor;
      if(current.svgData.backColor != '')
        this.backColor = current.svgData.backColor;
      if(current.svgData.openPolice){
        console.log('开始报警')
        let ms = 0;
        this.borderColor = current.svgData.polineColor||this.polineColor;
        let interCode = setInterval(()=>{
          if(ms % 2 != 0){
            this.borderColor = current.svgData.polineColor||this.polineColor;
          }else{
            this.borderColor = this.onLineColor;
          }
          ms++;
        },1000)
        this.interArr.push(interCode);
      }
      if(current.svgData.openOnLine){
        this.borderColor = this.onLineColor;
        // this.borderColor = this.defaultColor;
      }
      if(current.svgData.openOffLine){
        this.borderColor = this.defaultColor;
        // this.borderColor = current.svgData.offLineColor;
      }

      // 设置状态   openPolice: false, // 开启报警 openOnLine: false, // 是否在线openOffLine:false, // 是否离线
      this.message = this.message || {devName:current.svgData.devName || '门磁'}
      this.message.devId = current.svgData.devId
      this.message.state = true;
      this.message.txt =  current.svgData.openPolice?'报警': current.svgData.openOnLine?'在线':'离线';
      this.message.color =  current.svgData.openPolice?current.svgData.polineColor|| current.svgData.polineColor:this.openOnLine?current.svgData.onLineColor || this.onLineColor:current.svgData.onLineColor || this.onLineColor;
    
    })
  },
  beforeDestroy(){
    this.interArr.forEach(item=>{
      clearTimeout(item);
    })
  }
}
</script>


<style>
</style>